export default __webpack_public_path__ + "static/media/nfg-closed.3eca213d.jpeg";